import React from "react";
import { Loader2, MapPin, RotateCcw } from "lucide-react";
import { GEOCODE_STATE, popupRows } from "../mapPickModel";

// On this form, "what now" points below (the popup's wording points here).
const FORM_MESSAGES = {
  [GEOCODE_STATE.partial]: "Only part of this location could be identified: complete the place below and add it to the route.",
  [GEOCODE_STATE.notFound]: "No address was found at this point. The coordinates are kept: choose the place below and add it to the route.",
  [GEOCODE_STATE.failed]: "Location details could not be found right now. The coordinates are kept: try again, or choose the place below and add it to the route.",
  [GEOCODE_STATE.forbidden]: "You do not have permission to create journeys.",
  [GEOCODE_STATE.invalid]: "This map location is not valid, so nothing was pre-filled.",
};

// The banner on Add Journey when it was opened from a point on the map: what
// the point resolved to and what was pre-filled — or, honestly, what could not
// be. Fixed wording only (never a provider's or server's raw error).
export default function AddJourneyMapNotice({ prefill }) {
  const { point, invalid, geocode } = prefill;
  if (invalid) {
    return (
      <div className="tsp-map-notice tsp-map-notice--warn" role="status">
        <MapPin size={15} aria-hidden="true" /> The map location in this link is not a valid latitude / longitude, so nothing was pre-filled.
      </div>
    );
  }
  if (!point || geocode.state === GEOCODE_STATE.idle) return null;

  const rows = Object.fromEntries(popupRows(point, geocode.data).map((row) => [row.key, row.value]));
  const coords = `${rows.latitude}, ${rows.longitude}`;

  if (geocode.state === GEOCODE_STATE.loading) {
    return (
      <div className="tsp-map-notice" role="status">
        <Loader2 size={15} className="tsp-spin" aria-hidden="true" /> Finding the location selected on the map ({coords})…
      </div>
    );
  }

  if (geocode.state === GEOCODE_STATE.resolved) {
    const place = [rows.city, rows.district, rows.state].filter(Boolean).join(", ");
    return (
      <div className="tsp-map-notice tsp-map-notice--ok" role="status" data-testid="tsp-map-notice">
        <MapPin size={15} aria-hidden="true" />
        <span>
          Location selected on the map: <strong>{place}</strong>
          {rows.area ? ` · Area: ${rows.area}` : ""} ({coords}). State, district and taluka / town are filled in below — check them and add the location to the route.
        </span>
      </div>
    );
  }

  return (
    <div className="tsp-map-notice tsp-map-notice--warn" role="status" data-testid="tsp-map-notice">
      <MapPin size={15} aria-hidden="true" />
      <span>
        Location selected on the map ({coords}). {FORM_MESSAGES[geocode.state] || geocode.message}
      </span>
      {geocode.state === GEOCODE_STATE.failed && (
        <button type="button" className="tsp-btn tsp-btn-outline tsp-btn-sm" onClick={geocode.retry}>
          <RotateCcw size={13} aria-hidden="true" /> Try again
        </button>
      )}
    </div>
  );
}
